import styled from "styled-components"
import { device } from "breakpoints"
import { getGradientText } from "helpers/getGradientText"
import { getSolidColor } from "helpers/getSolidColor"
import { getGradient } from "helpers/getGradient"

import workQuote from "images/icons/work-quote.svg"
import businessQuote from "images/icons/business-quote.svg"
import liveQuote from "images/icons/live-quote.svg"
import studyQuote from "images/icons/study-quote.svg"
import visitQuote from "images/icons/visit-quote.svg"

const quoteMark = props => {
  if (props.theme.site === "work") {
    return workQuote
  } else if (props.theme.site === "business") {
    return businessQuote
  } else if (props.theme.site === "live") {
    return liveQuote
  } else if (props.theme.site === "study") {
    return studyQuote
  } else if (props.theme.site === "visit") {
    return visitQuote
  } else {
    return studyQuote
  }
}

export const ContainerInternalWSYSIWG = styled.div`
  padding-top: 30px;
  width: 100%;
  @media ${device.desktop} {
    padding-top: 70px;
    padding-right: 55px;
    padding-right: ${props => props.other && 0};
  }

  hr {
    margin: 30px 0;
    background: #d2d4e0;

    @media ${device.desktop} {
      margin: 60px 0 45px 0;
    }
  }

  h2,
  h3,
  h4,
  h5 {
    font-weight: 600;
    margin-bottom: 17px;
    color: ${props => props.theme.primaryColor};
    text-transform: inherit;

    @media ${device.desktop} {
      margin-bottom: 33px;
    }
  }
  h2 {
    font-size: 30px;
    letter-spacing: -0.31;
    line-height: 34px;
    @media ${device.desktop} {
      font-size: 42px;
      letter-spacing: -0.44px;
      line-height: 48px;
      margin-top: 45px;
    }
  }
  h3 {
    font-size: 24px;
    letter-spacing: -0.25px;
    line-height: 28px;
    padding-right: 11px;
    @media ${device.desktop} {
      font-size: 36px;
      letter-spacing: -0.38px;
      line-height: 42px;
    }
  }
  h4 {
    font-size: 20px;
    letter-spacing: -0.21px;
    line-height: 24px;
    @media ${device.desktop} {
      font-size: 32px;
      letter-spacing: -0.33px;
      line-height: 36px;
    }
  }
  h5 {
    font-size: 18px;
    letter-spacing: -0.19px;
    line-height: 24px;

    @media ${device.desktop} {
      font-size: 28px;
      letter-spacing: -0.29px;
      line-height: 32px;
    }
  }

  a {
    font-weight: 600;
    color: ${props => props.theme.primaryColor};
    position: relative;

    background-image: ${props =>
      `linear-gradient(to right, ${getSolidColor(
        props.theme.site
      )}, ${getSolidColor(props.theme.site)})`};
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-size: 100% 1px;

    @media ${device.desktop} {
      background-position: 0 97%;
    }

    :hover {
      background-size: 100% 0px;
    }
  }

  p {
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.13px;
    line-height: 24px;
    margin-bottom: 15px;

    @media ${device.desktop} {
      font-size: 20px;
      letter-spacing: -0.16px;
      line-height: 30px;
      margin-bottom: 22px;
    }

    > strong {
      font-weight: 600;
      color: #000;
    }
  }

  > p:first-of-type {
    font-size: 20px;
    letter-spacing: -0.16px;
    line-height: 27px;
    ${props => getGradientText(props.theme.site)}
    margin-bottom: 14px;

    @media ${device.desktop} {
      font-size: 28px;
      letter-spacing: -0.22px;
      line-height: 36px;
      margin-bottom: 24px;
    }
  }
  ul {
    margin-bottom: 84px;
    @media ${device.desktop} {
      margin-bottom: 62px;
    }
  }

  ul li {
    list-style: none;
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.12px;
    line-height: 24px;
    position: relative;
    margin-left: 16px;
    padding-left: 5px;
    margin-bottom: 16px;

    @media ${device.desktop} {
      font-size: 20px;
      letter-spacing: -0.16px;
      line-height: 30px;
      padding-left: 9px;
      margin-bottom: 20px;
    }

    :before {
      content: "";
      height: 6px;
      width: 6px;
      border-radius: 6px;
      position: absolute;
      top: 9px;
      left: -15px;
      background-color: ${props => getSolidColor(props.theme.site)};
      @media ${device.desktop} {
        top: 12px;
      }
    }
  }

  > ol {
    list-style: none;
    counter-reset: ordered-list;
    margin-bottom: 34px;

    @media ${device.desktop} {
      margin-bottom: 62px;
    }
  }
  > ol li {
    counter-increment: ordered-list;
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.12px;
    line-height: 24px;
    position: relative;
    margin-left: 36px;
    margin-bottom: 16px;
    @media ${device.desktop} {
      font-size: 20px;
      margin-left: 43px;
      margin-bottom: 26px;
    }

    :before {
      content: "";
      height: 4px;
      width: 4px;
      border-radius: 4px;
      position: absolute;
      top: 10px;
      left: -15px;
      background-color: #d2d4e0;
      @media ${device.desktop} {
        left: -19px;
      }
    }
    :after {
      content: counter(ordered-list);
      font-weight: bold;
      font-size: 20px;
      color: ${props => getSolidColor(props.theme.site)};
      letter-spacing: -0.16px;
      line-height: 24px;
      border-radius: 6px;
      position: absolute;
      top: -3px;
      left: -35px;
      @media ${device.desktop} {
        font-size: 24px;
        left: -40px;
      }
    }
  }

  blockquote {
    position: relative;
    margin-top: 45px;
    margin-bottom: 45px;

    @media ${device.desktop} {
      margin-top: 0;
      padding-left: 70px;
      margin-bottom: 50px;
    }

    :before {
      content: "";
      height: 38px;
      width: 45px;
      position: absolute;
      top: -45px;
      left: -3px;
      transform: scale(0.7);
      background-image: url(${quoteMark});

      @media ${device.desktop} {
        transform: scale(1);
        height: 37px;

        left: 1px;
        top: -11px;
      }
    }
    :after {
      content: "";
      height: 2px;
      width: 100%;
      position: absolute;
      bottom: 38px;
      left: 0;
      background-image: ${props => getGradient(props.theme.site)};
      @media ${device.desktop} {
        bottom: 49px;
        width: 90%;
        left: 70px;
      }
    }
    p {
      font-size: 20px;
      color: #4c4d58;
      letter-spacing: -0.16px;
      line-height: 27px;
      @media ${device.desktop} {
        font-size: 28px;
        letter-spacing: 0;
        line-height: 36px;
      }
      ::after {
        content: "”";
      }
    }
    cite {
      display: block;
      color: #727a7a;
      font-size: 12px;
      letter-spacing: -0.09px;
      line-height: 18px;
      margin-top: 41px;
      font-style: normal;

      @media ${device.desktop} {
        font-size: 16px;
        letter-spacing: -0.12px;
        line-height: 30px;
      }

      > strong {
        font-weight: 700;
        color: ${props => getSolidColor(props.theme.site)};
      }
    }
  }

  iframe {
    max-width: 100% !important;
  }

  figure.wp-block-image {
    margin: 36px auto;
    position: relative;
  }

  div.wp-block-image,
  figure.wp-block-image {
    margin: 34px auto;
    margin-bottom: 36px;
    position: relative;

    @media ${device.desktop} {
      margin: 51px auto;
      margin-bottom: 58px;
    }

    img {
      margin: 0;
      display: block;
      width: 100%;
      height: auto;
    }
  }

  div.wp-block-embed__wrapper {
    position: relative;
    padding-top: 56.25%;

    > iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  figcaption {
    margin-top: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #4c4d58;

    @media ${device.desktop} {
      font-size: 16px;
      left: 0;
      bottom: -54px;
      padding-left: 0;
      padding-bottom: 16px;
      padding-top: 19px;
      margin-top: 0px;
      width: 100%;
      z-index: 1;
    }

    :before {
      content: "";
      height: 2px;
      width: 100%;
      position: absolute;
      bottom: -4px;
      left: 0;
      background-color: ${props => getSolidColor(props.theme.site)};
    }
  }

  figure.wp-block-embed {
    position: relative;
    margin: 34px auto;

    @media ${device.desktop} {
      margin: 51px auto;
    }
  }

  div.wp-block-image {
    figure.alignleft {
      margin: 36px auto;

      img {
        display: block;

        width: 100%;
      }

      @media ${device.desktop} {
        float: left;
        width: calc(50% - 30px);
        margin-top: 0;
        margin-right: 60px;
        margin-bottom: 30px;
      }
    }
  }
`
